export const decodeUrlParamSafely = (rawParam: string): string => {
  const sanitized = rawParam.replace(/%(?![0-9a-fA-F]{2})/g, '%25');
  let decodedParam = rawParam;
  try {
    decodedParam = decodeURIComponent(sanitized);
  } catch (e) {
    console.warn('Invalid URL encoding:', rawParam, e);
  }
  return decodedParam;
};
